<template>
  <div class="d-flex flex-column" id="app">
    <Navbar :isLogin="memberin" />
    <GotoTop />
    <router-view class="position-relative flex-grow-1" v-if="isRouterAlive" />
  </div>
</template>

<script>
import GotoTop from './components/kit/Goto_top.vue'
import Navbar from './components/page/Navbar.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    GotoTop
  },
  provide () {
    return {
      reload: this.reload()
    }
  },
  data () {
    return {
      isRouterAlive: true,
      memberin: false
    }
  },
  watch: {
    $route () {
      const vm = this
      const api = `${process.env.VUE_APP_APIPATH}/api/user/check`
      vm.$http.post(api).then((response) => {
        vm.memberin = response.data.success
      })
    }
  },
  methods: {
    reload () {
      const vm = this
      vm.isRouterAlive = false
      vm.$nextTick(() => {
        vm.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/all';
</style>
